import React from 'react';
import { Button } from 'primereact/button';

const Invoice2 = (props) => {
    const print = () => {
        window.print();
    };

    return (
        <div>
            <Button type="button" label="Print" icon="pi pi-print" onClick={print} style={{ display: 'block', marginBottom: '20px', marginLeft: '6px' }}></Button>

            <div className="grid">
                <div className="col">
                    <div className="card">
                        <div id="invoice-content">
                            <div className="invoice">
                                <div className="invoice-header">
                                    <div className="invoice-company">
                                        {/* <img id="invoice-logo" className="logo-image" src={props.logoUrl} alt="diamond-layout" /> */}
                                        <div className="company-name">Software Type</div>
                                        <div>POS</div>
                                    </div>
                                    <div>
                                        <div className="invoice-title">QUOTATION (monthly)</div>
                                        <div className="invoice-details">
                                            <div className="invoice-label">Client: </div>
                                            <div className="invoice-value" style={{padding: 0, margin: 0, fontSize: '12px'}}>Designtexbd</div>
                                            <div className="invoice-label">Date</div>
                                            <div className="invoice-value" style={{padding: 0, margin: 0, fontSize: '12px'}}>28/02/2024</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-items">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{textAlign: 'left'}}>Service</th>
                                                <th style={{textAlign: 'left'}}>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{padding:'0'}}>
                                                    <ul style={{listStyleType:'none', textAlign: 'left'}}>
                                                        <li>1. Basic monthly subscription</li>
                                                        <li>2. Software Maintenance</li>
                                                        <ul>
                                                            <li>i. Software version upgrade (Django & React)</li>
                                                            <li>ii. Server update</li>
                                                            <li>iii. Daily database backup</li>
                                                        </ul>
                                                        <li>3. AWS cloud server cost</li>
                                                        <li>4. Old features upgrade (on demand)</li>
                                                        <li>5. New features develop (on demand)</li>
                                                    </ul>
                                                </td>
                                                <td  style={{textAlign: 'left'}}>13000 tk</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="invoice-summary">
                                    <div className="invoice-notes">
                                        <b>Terms of service</b>
                                        <div>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                i. <span>After fully software setup 1 month in advance.</span>
                                            </p>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                ii. <span>Monthly payment within 1st week.</span>
                                            </p>
                                            <p style={{padding: 0, margin: 0, fontSize: '12px'}}>
                                                iii. <span>Monthly payment will increase 15% yearly.</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="invoice-details">
                                            <div  style={{textAlign: 'left'}} className="invoice-label">SUBTOTAL</div>
                                            <div className="invoice-value">13000.00 tk</div>

                                            <div className="invoice-label">VAT</div>
                                            <div className="invoice-value">0 tk</div>

                                            <div className="invoice-label">TOTAL</div>
                                            <div className="invoice-value">13000.00 tk</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.logoUrl === nextProps.logoUrl;
};

export default React.memo(Invoice2, comparisonFn);
